import * as React from "react"
import { cn } from "../../../../lib/utils"

export interface DocumentTextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

export const DocumentTextarea = React.forwardRef<HTMLTextAreaElement, DocumentTextareaProps>(
  ({ className, onChange, ...props }, ref) => {
    const internalRef = React.useRef<HTMLTextAreaElement | null>(null);

    const adjustHeight = React.useCallback(() => {
      const textarea = internalRef.current;
      if (textarea) {
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
      }
    }, []);

    React.useEffect(() => {
      adjustHeight();
    }, [props.value, adjustHeight]);

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      onChange?.(e);
      adjustHeight();
    };

    const setRefs = React.useCallback(
      (node: HTMLTextAreaElement | null) => {
        internalRef.current = node;
        if (typeof ref === 'function') {
          ref(node);
        } else if (ref) {
          ref.current = node;
        }
        if (node) {
          // Adjust height on initial mount
          node.style.height = 'auto';
          node.style.height = `${node.scrollHeight}px`;
        }
      },
      [ref]
    );

    return (
      <textarea
        className={cn(
          "flex min-h-[80px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-subtle-foreground/50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 resize-none overflow-hidden",
          className
        )}
        ref={setRefs}
        onChange={handleChange}
        {...props}
      />
    )
  }
)
DocumentTextarea.displayName = "DocumentTextarea"
